import React from "react";

import { Payment } from "../store/payment/types";
import { SelectOptions } from "../assets/data/options";
import { useTranslation } from "react-i18next";

import {
  CommonSelect,
  CommonTextField,
} from "./index";

export const PaymentInfoField = ({
  id,
  values,
  errors,
  touched,
  setFieldValue,
  disableImmutable,
  className,
  disabled,
  noLabels,
}: any) => {
  //Hooks
  const { t } = useTranslation();

  //Helpers
  const shouldDisable = (key: string) => {
    return disabled || (disableImmutable && !Payment.updateFields.includes(key));
  };

  const getFormatter = (id: string) => {
    switch (id) {
      case "IBAN":
        return (value: any) => {
          const formatted = value
            .toString()
            .replace(/\W/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim();
          return formatted.toUpperCase();
        };
      default:
        return (value: any) => value;
    }
  }

  const getPlaceholder = (id: string) => {
    if (noLabels) {
      return null;
    }

    switch (id) {
      case "bank":
        return t("Select...");
      case "IBAN":
        return t("IBAN");
      default:
        return null;
    }
  }

  const getLabel = (id: string) => {
    if (noLabels) {
      return null;
    }

    switch (id) {
      case "bank":
        return t("Payment method");
      default:
        return null;
    }
  }

  const getOptions = (id: string) => {
    switch (id) {
      case "bank":
        return SelectOptions()["paymentMethod"];
      default:
        return null;
    }
  }

  //Options
  const label = getLabel(id);
  const placeholder = getPlaceholder(id);
  const onChangeFormat = getFormatter(id);
  const options = getOptions(id);

  switch (id) {
    case "IBAN":
      return (
        <CommonTextField
          disabled={shouldDisable(id)}
          id={id}
          placeholder={placeholder}
          values={values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          className={className}
          onChangeFormat={onChangeFormat}
        />
      );
    case "bank":
      return (
        <CommonSelect
          disabled={shouldDisable(id)}
          id={id}
          label={label}
          placeholder={placeholder}
          values={values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          options={options}
          className={className}
        />
      );
    default:
      return <></>;
  }
};
